export const RouteGetViolationMerchflow_merchflowId_ = "/violation/merchflow/:merchflowId";

// storeCode -> (reason category -> number of items).
export type ViolationReasonBreakdown = Record<string, Record<string, number>>;

export interface ViolationReport {
  violation_type: string;
  violation_message: string;
  stores_affected: string[];
  fix: string[];
  // Present only for alerts that surface a per-store breakdown of unranged-item reason categories
  // (e.g. the "Top quartile sales alert").
  reason_breakdown?: ViolationReasonBreakdown;
}

export interface ResponseGetViolationMerchflow_merchflowId_ {
  data: ViolationReport[];
}
